import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, useBreakpointValue, useHoverable } from "@gemini/core";
import { useI18n } from "@/shared/hooks";
import { useCustomerAction } from "@/hooks";
import { InteractionEnum } from "@/types";
import { AddressUnpublishedHint, Card, MapCardFallback } from "./ui";
import { Button } from "@gemini/ui";
import { ArrowMaximiseIcon } from "@gemini/icons";
import { useMapContext } from "@/domains/map";
import { useMapCard } from "@/location/hooks";
import { useLocation } from "@/location/hooks/useLocation";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { useCdpNavigate } from "@/app/router";
import { CLIENT_ROUTES } from "@/app/router/constants";
export const mapCardTestId = "cdp-mapcard";
export const MapCard = () => {
    const location = useLocation();
    const { t } = useI18n();
    const { setIsSidebarOpen } = useMapContext();
    const { boxProps, isHovered } = useHoverable();
    const mapboxImageUrl = useMapCard();
    const { customerActionExposeInteraction } = useCustomerAction();
    const isPreviewMode = useIsPreviewMode();
    const isMobile = useBreakpointValue({
        base: true,
        md: false,
    });
    const navigate = useCdpNavigate();
    if (!location)
        return null;
    const { isAddressPublished, isGeoDataDefined } = location;
    const handleCardClick = () => {
        if (isPreviewMode)
            return;
        customerActionExposeInteraction([
            { key: "interaction", value: InteractionEnum.OPEN_MAP },
        ]);
        if (isMobile) {
            setIsSidebarOpen(false);
        }
        navigate(CLIENT_ROUTES.MAP);
    };
    if (!isGeoDataDefined)
        return _jsx(MapCardFallback, {});
    return (_jsx(_Fragment, { children: _jsxs(Card, { onClick: handleCardClick, testId: mapCardTestId, marginTop: "spacing.16", minHeight: "300px", width: "100%", unsafe_className: "HideOnPrint", pointerEvents: isPreviewMode ? "none" : "auto", display: "flex", flexDirection: "column", children: [_jsx(Button, { position: "absolute", top: "spacing.8", right: "spacing.8", variant: "secondary-floating", iconOnly: true, icon: ArrowMaximiseIcon, size: "32", onPress: handleCardClick, zIndex: "zIndex.1", children: t("location.map.button.aria_label") }), _jsxs(Box, Object.assign({ as: "button", cursor: "pointer", width: "100%", height: "300px", borderStyle: "none", padding: 0, "aria-label": t("location.map.button.aria_label") }, boxProps, { children: [_jsx(Box, { as: "img", alt: t("location.map.image.alt"), src: mapboxImageUrl, objectFit: "cover", width: "100%", height: "100%", loading: "lazy" }), isHovered && (_jsx(Box, { position: "absolute", top: 0, left: 0, width: "100%", height: "100%", unsafe_style: { backgroundColor: "rgba(0, 0, 0, .1)" } }))] })), !isAddressPublished && (_jsx(AddressUnpublishedHint, { testId: `${mapCardTestId}-hint`, children: t("location.map.unpublished_address_hint") }))] }) }));
};
